// dependencies
import React from "react";
import { View, StyleSheet } from "react-native";

// hocs
import withMedia from "../../hocs/withMedia";

// components
import BaseComponent from "../BaseComponent";
import PlaceholderView from "../PlaceholderView";
import { Row, Col } from "../Grid";
import { List, ListItem } from "../List";
import Stack from "../Stack";
import RateListPlaceholder from "./RateListPlaceholder";

type PropsType = {
  matches?: boolean;
};

const getStyles = ({ matches }) =>
  StyleSheet.create({
    avatar: {
      width: "4.375em",
      height: "4.375em",
    },
    customer: {
      justifyContent: "center",
      alignItems: "center",
      borderStyle: "solid",
      borderColor: "#000000",
      borderRightWidth: matches ? 2 : 0,
    },
  });

const CommentPlaceholder: React.FunctionComponent<PropsType> = (props) => {
  const { matches } = props;

  const styles = getStyles({ matches });

  return (
    <BaseComponent>
      <Row
        breakpointList={{ all: Infinity }}
        col={{ all: matches ? 4 : 1 }}
        gutter={matches ? 0.625 : 0.3125}
      >
        <Col>
          <View style={styles.customer}>
            <View style={styles.avatar}>
              <PlaceholderView style={{ width: "100%", height: "100%" }} />
            </View>

            <Stack marginTop={0.125} />

            <PlaceholderView style={{ width: "4.375em", height: "1.0625em" }} />

            <Stack marginTop={0.125} />

            <PlaceholderView style={{ width: "10em", height: "1.375em" }} />

            <Stack marginTop={0.125} />

            <PlaceholderView style={{ width: "10em", height: "0.75em" }} />

            <Stack marginTop={0.125} />

            <PlaceholderView style={{ width: "5em", height: "0.875em" }} />
          </View>
        </Col>

        <Col span={matches ? 3 : 1}>
          <View style={{ height: "100%", justifyContent: "center" }}>
            <List gutter={0.625} inline={matches}>
              <ListItem style={{ alignItems: "center" }}>
                <PlaceholderView
                  style={{ width: "6.875em", height: "1.3125em" }}
                />
              </ListItem>

              <ListItem style={{ alignItems: "center" }}>
                <PlaceholderView style={{ width: "80%", height: "1.3125em" }} />
              </ListItem>
            </List>

            <Stack marginTop={0.625} />

            <PlaceholderView style={{ width: "100%", height: "3em" }} />

            <Stack marginTop={0.625} />

            <RateListPlaceholder />
          </View>
        </Col>
      </Row>
    </BaseComponent>
  );
};

export default withMedia({
  query: { minWidth: 800 },
  breakpointType: "element",
})(CommentPlaceholder);
